import { Box, Button } from '@hover/blueprint';
import React from 'react';

import {
  desktopNavbarHeight,
  mobileNavbarHeight,
} from 'src/modules/homeownerApp/components/Navbar';
import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks';
import { Logo } from 'src/shared/components';

export const Header = () => {
  const t = useHomeownerTranslate();

  return (
    <Box
      alignItems="center"
      height={{
        base: `${mobileNavbarHeight}px`,
        tablet: `${desktopNavbarHeight}px`,
      }}
      justifyContent="space-between"
      paddingTop={400}
      paddingX={400}
      width={1}
    >
      <Logo color="inherit" />
      <Button variant="tertiary">{t('pro.getInTouch')}</Button>
    </Box>
  );
};
